import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';
import { useCallback } from 'react';
import { useToggle } from 'react-use';
import ErrorBoundary from 'react-error-boundary';

export default function ErrorBoundaryResettable({
  FallbackComponent,
  children,
  sentryErrorBoundary = false,
  onError = () => {},
}) {
  const [key, toggleKey] = useToggle();

  const updateKey = useCallback(() => toggleKey(), [toggleKey]); // Always toggles

  const FallbackComponentWithReset = useCallback(
    (props) => <FallbackComponent onReset={updateKey} {...props} />,
    [FallbackComponent, updateKey]
  );

  if (sentryErrorBoundary && import.meta.env.MODE === 'production') {
    return (
      <SentryErrorBoundary fallback={FallbackComponentWithReset} key={key}>
        {children}
      </SentryErrorBoundary>
    );
  }

  return (
    <ErrorBoundary
      key={key}
      FallbackComponent={FallbackComponentWithReset}
      onError={onError}
    >
      {children}
    </ErrorBoundary>
  );
}
